export const isValidWhatsApp = (phoneStr) => {
    if (!phoneStr) return false;
    const str = String(phoneStr);
    const digits = str.split('@')[0].replace(/\D/g, '');
    if (digits.length < 8 || digits.length >= 15) return false;
    if (str.includes('@lid') || str.includes('broadcast') || str.includes('newsletter')) return false;
    return true;
  };
